export const RecordSettingsFragment = gql`
  fragment RecordSettingsFragment on RecordSettings {
    advancePastInspectionsMode
    allowAnonymousSubmissions
    defaultInvoiceDueDateTemplate {
      ...DateTemplateFragment
    }
    defaultLetterhead {
      id
    }
    enableApplicantDocumentPrivacy
    enableCloseRecord
    enableAddWorkflow
    enableApplicationAutoCheck
    enableApplicationAutoCheckForApplicants
    finalReviewerUser {
      ...UserDataFragment
    }
    shouldDisablePlanReviewAcceptedEmail
    shouldPromoteTagsForStaff
    shouldExposeTagsToCitizens
    disableApplicantsUploadFilesNotInPlanSet
    inspectionSchedulingIntakeFormFieldGroup {
      id
    }
    inspectionCoordinationType
    inspectionCutoffTime
    inspectionMaxTries
    inspectionSchedulingInstructions
    inspectionRequestSchedulingMode
    inspectionSchedulingShouldShowTimesToApplicants
    issuedIdentifierYearCutoff {
      day
      month
    }
    lateFeeConfiguration {
      ...LateFeeConfigurationFragment
    }
    isOnlinePaymentsEnabled
    additionalInvoiceInstructions
    setExpirationAtIssueDateTemplate {
      ...DateTemplateFragment
    }
    setExpirationAtIssueRecordTypeStatus {
      ...RecordTypeStatusFragment
    }
    shouldDisablePlanReviewAcceptedEmail
    trackApplicants
  }
`

export const OverridableRecordSettingsFragment = gql`
  fragment OverridableRecordSettingsFragment on RecordSettings {
    disableApplicantsUploadFilesNotInPlanSet
    finalReviewerUser {
      ...UserDataFragment
    }
    lateFeeConfiguration {
      ...LateFeeConfigurationFragment
    }
    isOnlinePaymentsEnabled
    setExpirationAtIssueDateTemplate {
      ...DateTemplateFragment
    }
  }
`

export const OverridableRecordSettingSourcesFragment = gql`
  fragment OverridableRecordSettingSourcesFragment on RecordSettingSources {
    disableApplicantsUploadFilesNotInPlanSet {
      ...RecordSettingSourceFragment
    }
    finalReviewerUser {
      ...RecordSettingSourceFragment
    }
    lateFeeConfiguration {
      ...RecordSettingSourceFragment
    }
    isOnlinePaymentsEnabled {
      ...RecordSettingSourceFragment
    }
    setExpirationAtIssueDateTemplate {
      ...RecordSettingSourceFragment
    }
  }
`

export const RecordSettingSourceFragment = gql`
  fragment RecordSettingSourceFragment on RecordSettingSource {
    id
    type
  }
`
